/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntitlementDTO
 */
export interface EntitlementDTO {
    /**
     * 
     * @type {string}
     * @memberof EntitlementDTO
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EntitlementDTO
     */
    expireDate?: Date | null;
}

/**
 * Check if a given object implements the EntitlementDTO interface.
 */
export function instanceOfEntitlementDTO(value: object): value is EntitlementDTO {
    return true;
}

export function EntitlementDTOFromJSON(json: any): EntitlementDTO {
    return EntitlementDTOFromJSONTyped(json, false);
}

export function EntitlementDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntitlementDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'expireDate': json['expireDate'] == null ? undefined : (new Date(json['expireDate'])),
    };
}

export function EntitlementDTOToJSON(json: any): EntitlementDTO {
    return EntitlementDTOToJSONTyped(json, false);
}

export function EntitlementDTOToJSONTyped(value?: EntitlementDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'expireDate': value['expireDate'] == null ? value['expireDate'] : value['expireDate'].toISOString(),
    };
}

